import { documentApi } from '@/entities/Document';
import api from '@/shared/api';
import { findRevision } from './revision-selection';
import useRevisionFileDelivery, { type RevisionFileData } from './useRevisionFileDelivery';

const BASE_PATH = 'homologations/documents';

export default function useHomologations() {
  const { error, isLoading, deliverRevisionFile, runFileDelivery } = useRevisionFileDelivery();

  const getRevisions = async (
    documentId: string,
    revisionId: number
  ): Promise<RevisionFileData[]> => {
    const apiResponse = await api.get(`${BASE_PATH}/${documentId}`, {
      params: { revisionId },
    });
    return apiResponse.data.data.revisions;
  };

  const registerView = async (documentId: string, revision: RevisionFileData) => {
    try {
      await documentApi.registerDocumentView(Number(documentId), revision.id, BASE_PATH);
    } catch {
      // best-effort: falha ao registrar auditoria não deve impactar a visualização
    }
  };

  const viewHomologationDocument = async (documentId: string, revisionId: number) =>
    runFileDelivery(async () => {
      const revisions = await getRevisions(documentId, revisionId);
      const revision = findRevision(revisions, revisionId);

      await deliverRevisionFile(
        revision,
        (endpoint) => ({
          path: `/${BASE_PATH}/${documentId}/${endpoint}`,
          params: { revisionId },
        }),
        (openedRevision) => registerView(documentId, openedRevision)
      );
    });

  return {
    viewHomologationDocument,
    error,
    isLoading,
  };
}
